export class AppConstants {

	public static get baseServidor(): string {
	  return "https://painel.wowcorp.com.br/pdv"
	 //return "http://localhost:8083/pdv"
	}

	public static get baseLogin(): string {
		return this.baseServidor + "/login"
	}

	public static get baseUrl(): string {
		return this.baseServidor + "/user/"
	}

	public static get getBaseUrlPath(): string {
		return this.baseServidor + "/"
	}
}
